import React from 'react';
import { useHistory } from 'react-router';
import Breadcrumb from '../../Components/Common/Modules/Breadcrumb';
import TitleWeb from '../../Components/Common/Web/Title';
import ContactoDudasBanner from '../../Components/Common/Banners/ContactoDudas';
import Toast from '../../Components/Common/Modules/Toast';
import Button from '../../Components/Common/Modules/Button';
import FormRow from '../../Components/Common/Atoms/Form/FormRow';
import PathsConfig from '../../Config/RoutePaths';
import Divider from '../../Components/Common/Atoms/Divider';
import useRedirectWithout from '../../Hooks/useRedirectWithout';

export const ActivarBonificadaConfirmacion = (props) => {
    const history = useHistory();
    const stepProps = ['activacionExitosa'];
    const { _ } = useRedirectWithout(
        props.location.state,
        stepProps,
        PathsConfig.VincularCredencialMiClub
    );

    return (
        <section className="container-streched">
            <Breadcrumb
                firstItem="Club LA NACION"
                text="Vincular credencial"
                href="#"
            />
            <TitleWeb text="Acceso Digital" />
            <fieldset>
                <Toast status="success" title={'¡Ya sos suscriptor digital!'}>
                    Seguí disfrutando LA NACION sin límites.
                </Toast>
                <FormRow mod="--btn-groups">
                    <Button label="IR A LA NACION" tag="a"
                        className="--mb-0"
                        mod="primary"
                        href={'https://www.lanacion.com.ar'} />
                    <Button href={'#'} mod="secondary" label="VOLVER"
                        onClick={() => {
                            history.replace({
                                pathname: PathsConfig.VincularCredencialMiClub
                            })
                        }} />
                </FormRow>
                <Divider />
                <ContactoDudasBanner />
            </fieldset>

        </section>
    );
}